import React from 'react';
import Modal from 'react-responsive-modal';
import cn from 'classnames';
import _ from 'lodash';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import { SimpleDateSelector } from '../selectors/date/SimpleDateSelector';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('EXCHANGE_RATES_IMPORT_MODAL_V2', LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES = {
    modal: 'modal-max-width-65'
};

const ExchangeRatesImportModalV2 = ({open = false, startDate = '', endDate = '', onStartImport = () => {}, onCancel = () => {}, onDateChange = () => {}}) => {
    log.debug('ExchangeRatesImportModalV2 render with props: ', {open, startDate, endDate});

    const handleStartImport = (event) => {
        log.debug('onStartImport(): event: ', event);
        onStartImport();
    };

    const handleCancel = (event) => {
        log.debug('onCancel(): event: ', event);
        onCancel();
    };

    const handleSelectionChange = (keyValue) => {
        log.debug('selectionHandler() - keyValue: ', keyValue);
        onDateChange(keyValue);
    };

    const startImportClasses = cn('primary', {'disabled': _.isEmpty(startDate) || _.isEmpty(endDate)});

    return (
        <div data-test="component-exchange-rates-operation-import-modal">
            <Modal center
                classNames={MODAL_CLASSNAMES}
                open={open}
                closeOnOverlayClick={false}
                onClose={handleCancel}
            >
                <h2><LanguageStringResolver string='importExchangeRatesModal_retrieveOnline' /></h2>
                <s-box name='form-panel'>
                    <p>
                        <LanguageStringResolver string='importExchangeRatesModal_description_1' />
                        <br/>
                        <LanguageStringResolver string='importExchangeRatesModal_description_2' />
                    </p>
                    <fieldset>
                        <s-row>
                            <s-col span="6">
                                <label className="mt0 mr20"><LanguageStringResolver string='importExchangeRatesModal_StartDate' /></label>
                                <SimpleDateSelector 
                                    selectionHandler={handleSelectionChange}
                                    fieldName={'exchangeRatesStartDate'}
                                    format="yyyy-mm-dd"
                                    value={startDate || ''}
                                />
                            </s-col>
                            <s-col span="6">
                                <label className="mt0 mr20"><LanguageStringResolver string='importExchangeRatesModal_EndDate' /></label>
                                <SimpleDateSelector 
                                    selectionHandler={handleSelectionChange}
                                    fieldName={'exchangeRatesEndDate'}
                                    format="yyyy-mm-dd"
                                    value={endDate || ''}
                                />
                            </s-col>
                        </s-row>
                        <div className="clear"/>
                    </fieldset>
                </s-box>
                
                <div className="mt20">
                    <button className={startImportClasses} onClick={handleStartImport} disabled={_.isEmpty(startDate) || _.isEmpty(endDate)}>
                        <span>
                            <LanguageStringResolver string='importExchangeRatesModal_StartImport' />
                        </span>
                    </button>
                    <button
                        className="secondary ml10"
                        onClick={handleCancel}>
                        <span>
                            <LanguageStringResolver string='importExchangeRatesModal_CancelImport' />
                        </span>
                    </button>
                </div>
            </Modal>
        </div>
    );
};


export default ExchangeRatesImportModalV2;

